export default __webpack_public_path__ + "static/cy-0444dfb90b6ab80fbc545f44990dac7a.svg";